import { getPaths, getProps } from "@up/data";
import Cookies from "js-cookie";
import Head from "next/head";
import { useEffect, useRef } from "react";

import SliceRender from "~/components/SliceRender";

export async function getStaticPaths() {
  return getPaths((page) => {
    return !page.uid.match("college-credit");
  });
}

export async function getStaticProps(context) {
  return getProps(context);
}

const getVariant = (test) => {
  const id = test.id;
  const cookie = Cookies.get(id);
  const variant = cookie || new Date() % 2;
  Cookies.set(id, variant);
  return {
    ...test,
    variant: variant.toString(),
  };
};

const Page = function (props) {
  const desc = props.page.data?.description;
  const title = props.page.data?.title;
  const uid = props.uid;
  const catalogueId = props.page.data?.backoffice_catalogue_id;
  const courseName =
    props.page.data?.is_course_page || props.page.data?.course_name
      ? props.uid
      : null;
  const experiments = useRef([
    getVariant({
      id: "up-test-1",
      name: "UP Test - Georgetown New Course Listing - June 2025",
    }),
  ]);

  useEffect(() => {
    if (!window.heap) {
      return;
    }

    const heapProps = experiments.current.reduce(
      (acc, { name, variant }) => ({ ...acc, [name]: variant }),
      {},
    );

    window.heap.addEventProperties(
      experiments.current.reduce(
        (acc, { id, variant }) => ({ ...acc, [id]: variant }),
        {},
      ),
    );
    window.heap.addEventProperties(heapProps);
    window.heap.addUserProperties(heapProps);
  }, []);

  return (
    <>
      <Head>
        {title && <title key="title">{title}</title>}
        {desc && <meta key="description" name="description" content={desc} />}
        {desc && (
          <meta key="og:description" property="og:description" content={desc} />
        )}
        {catalogueId ? (
          <meta
            key="catalogueid"
            name="catalogueid"
            id="catalogueid"
            content={catalogueId}
          />
        ) : null}
        {courseName ? (
          <meta
            key="coursename"
            name="coursename"
            id="coursename"
            content={courseName}
          />
        ) : null}
      </Head>
      {SliceRender({
        prismicData: props.page.data.page_content,
        cohortData: props.cohortData,
        reusableContentData: props.reusableContentData,
        uid,
        isCoursePage: Boolean(catalogueId),
        experiments: experiments.current,
      })}
    </>
  );
};

export default Page;
